import { SagaIterator } from 'redux-saga';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import {
  GlobalActions,
  GlobalPut,
  NavigationRoute,
  ProvideVorvertragStatusValidationPayload,
} from '@ps20-frontend/shop-integration-redux';
import { App, AppSubroute } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { ThhPferdActions } from '../thhPferdActions';

export function* handleThhPferdNavigationToAngebotSaga(): SagaIterator {
  yield takeEvery(
    ThhPferdActions.HANDLE_THH_PFERD_NAVIGATION_TO_ANGEBOT,
    safeSaga(handleThhPferdNavigationToAngebot, App.THH_PFERD),
  );
}

export function* handleThhPferdNavigationToAngebot(): SagaIterator {
  const globalPut = GlobalPut.getInstance();
  const globalActions = new GlobalActions();
  const state: IAppState = yield select();

  yield call(
    globalPut.put,
    globalActions.requestVorvertragStatusValidation({
      appId: App.THH_PFERD,
      angebotsId: state.angebotsId,
      selectedVorvertragsNummern: state.vertragsoptionen?.vorvertragsNummern || [],
    }),
  );
  const contractValidationAction = yield take(
    GlobalActions.PROVIDE_VORVERTRAG_STATUS_VALIDATION,
  );
  const {
    validationResult: contractValidationResult,
    appId: contractAppId,
    angebotsId: contractAngebotsId,
  }: ProvideVorvertragStatusValidationPayload = contractValidationAction.payload;

  if (
    !(
      contractAppId === App.THH_PFERD &&
      contractAngebotsId === state.angebotsId &&
      contractValidationResult == null
    )
  ) {
    return;
  }

  yield put(new ThhPferdActions().quoteDBRequested());
  yield put(new ThhPferdActions().preiseRequested());
  yield put(new ThhPferdActions().zumAngebotButtonClicked());
  const navRoute: NavigationRoute = {
    appId: App.THH_PFERD,
    subroute: AppSubroute.TAA_ANGEBOT,
  };
  return yield call(globalPut.put, globalActions.navigationRequested(navRoute));
}
